/* What a customer is about to pay when a card is charged for lines in arrears (#114).
 * Used by the card-update page and the retry-same-card button, so both show the same numbers.
 *
 * This mirrors the server's own sum in sim_activations_user.hooks.js (billTotalDue: lines that
 * shouldBill, max(cyclesDue,1) x bill). The server works the amount out again itself - this is only
 * what we show. cyclesDue comes from calculateArrears in rebilling_methods.js. */
import {israelPhoneMobileNormalize} from '../common_israel_mobiles.js';

export function monthsDue(line){
	if(!line || !line.active || !line.bill || !line.shouldBill || !line.shouldBill.bill) return 0;
	return Math.max(line.cyclesDue||1, 1);
	}

export function amountDue(line){
	return monthsDue(line) * (line ? line.bill : 0);
	}

//{lines, total, months} for the lines that will actually be charged
export function arrearsFor(lines){
	const due = lines.filter(line=>monthsDue(line)>0);
	return {
		lines: due
		,total: due.reduce((sum,line)=>sum+amountDue(line),0)
		,months: due.reduce((sum,line)=>sum+monthsDue(line),0)
		};
	}

export function describeLine(line){
	const months = monthsDue(line);
	return `${israelPhoneMobileNormalize(line.israel_number)}: ${months} month${months==1?'':'s'} × ₪${line.bill} = ₪${amountDue(line)}`;
	}

//The same sentence on both pages, for the warning box and the confirm dialog
export function arrearsHtml(arrears){
	return `This pays <b>${arrears.months} month${arrears.months==1?'':'s'}</b> owed and brings your account fully up to date:<br>`
		+ arrears.lines.map(line=>'&bull; '+describeLine(line)).join('<br>');
	}
